"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.create.title': 'Iniciar Nuevo Onboarding',
};
